"use strict";

import { default as LandingPage } from '../scenes/Landing';
export default LandingPage;